<ng-container *appTranslate="let t">
  <div class="page" style="background: var(--p-gradient)">
    <ui-pageheader
      class="bg-transparent"
      [caption]="title"
      [description]="dashboardVisibility()?.isVisible ? t('dashboard.description') : undefined"
    />

    @if (dashboardVisibility().isVisible) {
      <article class="content">
        @if (brandingWidgets().length > 0) {
          <div class="px-11 pt-11 col gap-4">
            @for (widget of brandingWidgets(); track widget.widgetId) {
              <new-ui-dashboard-branding-widget [widget]="widget" />
            }
          </div>
        }

        <!-- Half-height tracks, so a tile can be sized in steps of half a card rather than whole ones: two
           tracks and the gap between them make the 272px a plain tile has always been (128 * 2 + 16), four
           make 560, six make 848. Every span below is therefore twice what it reads as. -->
        <div class="p-11 col gap-4">
          <div class="grid auto-rows-[128px] grid-cols-1 mobile:grid-cols-4 gap-4">
            <new-ui-dashboard-open-tasks
              class="col-span-1 row-span-2"
              [class.mobile:col-span-2]="!settings.isCandidate"
              [class.mobile:col-span-4]="settings.isCandidate"
            />
            @if (!settings.isCandidate) {
              <new-ui-dashboard-sharing class="col-span-1 mobile:col-span-2 row-span-2" />

              <new-ui-dashboard-events class="col-span-1 mobile:col-span-2 row-span-2" />
              <new-ui-dashboard-candidate-status class="col-span-1 mobile:col-span-2 row-span-2" />

              @if (dashboardVisibility().talentPool) {
                <new-ui-dashboard-talent-pool-requests class="col-span-1 mobile:col-span-2 row-span-2" />
                <new-ui-dashboard-talent-pool-sharings class="col-span-1 mobile:col-span-2 row-span-2" />
              }
            } @else {
              <new-ui-dashboard-milestone-candidate class="col-span-1 mobile:col-span-4 row-span-2" />
            }
          </div>

          @if (!settings.isCandidate) {
            <!-- Outside the grid, so the tile takes the timeline's own height: its rows and summary band rarely
               add up to a whole number of tracks, and rounding up left a good part of the tile empty. It spans
               the full width anyway, and the tiles above always fill their rows, so splitting the grid here
               moves nothing. -->
            <new-ui-dashboard-milestone-planning />

            <div class="grid auto-rows-[128px] grid-cols-1 mobile:grid-cols-4 gap-4">
              <new-ui-dashboard-birthdays class="col-span-1 row-span-4" />

              <new-ui-dashboard-release-notes-notes class="col-span-1 mobile:col-span-3 row-span-4" />
            </div>
          }
        </div>
      </article>
    }
  </div>
</ng-container>
